import React from 'react';
export const arrowRightSvg = () => {
    return (
        <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.37231 10.59L2.81563 6L7.37231 1.41L5.96949 1.73544e-08L3.55385e-05 6L5.96949 12L7.37231 10.59Z" fill="black" fillOpacity="0.2"/>
        </svg>
    )
}